import { Chip, chipClasses } from '@mui/material';

interface IProps {
  checked?: boolean;
  label: string;
}

const TabChip = ({ checked, label }: IProps) => {
  return (
    <Chip
      sx={{
        minWidth: 61,
        [`&.${chipClasses.outlined}`]: {
          color: '#2E2C34',
          backgroundColor: 'white',
        },
        [`&.${chipClasses.filled}`]: {
          padding: '1px',
        },
      }}
      color={checked ? 'primary' : 'default'}
      variant={checked ? 'filled' : 'outlined'}
      label={<span className='text-[14px] font-[Manrope] font-semibold'>{label}</span>}
    />
  );
};

export default TabChip;
